import React, { Component } from 'react';
import FormField from "../Components/FormField"

import './Wedding.css';
import swal from 'sweetalert';



let api = "https://api.lushplans.com/"
export default class Wedding extends Component {
  constructor(props) {
    super(props)    
   
    this.state = {      
      currentTab : 0,
      disableNextTabButton : false,
      nextButtonText : "NEXT",
      forms : [],
      showReviewPage : false,
      showTabs : true,
      showErrorMessage : false,      
      errorMessage : "",
      data : {

      },
      data_status : {
        
      },
      coupleForm : {
        title : "Couple Information",
        name : "couple",
        length : 4,
        form : [
          {
            name: "bride.firstName",
            label: "Bride's first name",
            type: "text",        
          },
          {
            name: "bride.lastName",
            label: "Bride's last name",
            type: "text",        
          },
          {
            name: "groom.firstName",
            label: "Groom's first name",
            type: "text",        
          },
          {
            name: "groom.lastName",
            label: "Groom's last name",
            type: "text",        
          },
        
        ]},
      parentForm : {
        title : "Parents Information",  
        name : "parents", 
        length : 4,     
        form : [
          {
            name: "bride.name",
            label: "Bride's parents",
            type: "text",        
          },
          {
            name: "bride.from",
            label: "From",
            type: "text",        
          },
          {
            name: "groom.name",
            label: "Groom's parents",
            type: "text",        
          },
          {
            name: "groom.from",
            label: "From",
            type: "text",        
          },
        
        ]
      },
      weddingForm : {
        title : "Wedding Event",
        name : "events",
        multiple : true,
        length : 7,
        form : [
          {
            name: "name",
            label: "Name of Event",
            type: "text",
          },
          {
            name : "date",
            label : "Date",
            type : "date"
          },
          {
            name: "time",
            label: "Time",
            type: "time",
          },
          {
            name: "venue",
            label: "Location",
            type: "text",
          },
          {
            name : "color.primary",
            label : "Main Event Color",
            type : "color"
          },
          {
            name: "color.secondary",
            label: "Accent Color",
            type: "color",
          },
          {
            name: "color.description",
            label: "Name your color ",
            type: "text",
          },
        ]
      },
      contactForm : {
        title : "RSVP Contact Information",
        name : "contact",
        multiple : true,
        length : 3,
        form : [
          {
            name : "name",
            label : "Contact name",
            type : "text",
          },         
          {
            name : "phone",
            label : "Phone",
            type : "tel",
            default : ""            
          },
          {
            name : "email",
            label : "Email",
            type : "email",
            default : ""            
          }
        ]
      },
      extraInfoForm : {
        title : "Comments/Directions for Guests",
        name : "extra",
        multiple : true,
        length : 2,
        form : [
          {
            name : "title",
            label : "Title",
            type : "text",
          },         
          {
            name : "detail",
            label : "Detail",
            type : "text",
            default : ""            
          }
        ]
      }
    }
      

  }

  componentDidMount(){ 
    const forms = [this.state.coupleForm, this.state.parentForm, this.state.weddingForm, this.state.contactForm, this.state.extraInfoForm]
    let data = {}
    for(let item in forms){
        const formName = forms[item].name
        data[formName] = {}
    }
    this.setState({
      forms : forms,
      data : data
    })
  }

  onEditForm = (newForm, formName, removedIndex) => {    
    let forms = Object.assign(this.state.forms)
    forms.map((item, index) => {
      if(item.name === formName){
        item.form = newForm
      }
      return item
    })
    
    this.setState({
      forms : forms
    })

    if(removedIndex){
      let new_data = Object.assign({}, this.state.data)
      for(let item in new_data){
        if(item === formName){
          Object.keys(new_data[item]).map((elem, index) => {
            if(elem[elem.length-1] === removedIndex){
              delete new_data[item][elem]
            }
            return null;
          })
        }
      }

      this.setState({ data : new_data })
    }
  }

  saveToState = (data, isValid, formName) => {
    const { name, value } = data    
    
    const newFormData = Object.assign(this.state.data[formName], {[name]: value})  
    const newData = Object.assign(this.state.data, { [formName] : newFormData})
    this.setState({ 
      data : newData,
      data_status : Object.assign(this.state.data_status, {[name] : isValid})
    });

  }

  formIsValid = (form) => {  
    // return true
    // TODO: enable later
    for(let field in form){
      const currentField = form[field]
      console.log(currentField, field, form)
      if(this.state.data_status[currentField.name]){
        continue
      }
      else{
        let name = currentField.name.split(".")
        if(name[1]){
          name[1] = name[1].toLowerCase()
        }        
        name = name.join(" ")
        this.setState({
          errorMessage : "Please enter a valid " + name
        })
        return false
      }
    }

    return true
  }


  nextTab = () => {
    // if(true){
    if(this.formIsValid(this.state.forms[this.state.currentTab].form)){
        this.setState({
          showErrorMessage : false,
          errorMessage : ""
        })

        if(this.state.currentTab === (this.state.forms.length - 1)){
          this.setState({ 
            showReviewPage : true,
            showTabs : false
          })
        } 

        if(this.state.currentTab !== (this.state.forms.length - 1)){
          this.setState({      
            currentTab : this.state.currentTab + 1
          }, () => {
            // Check if this is the last tab
            if(this.state.currentTab === (this.state.forms.length - 1)){
              this.setState({ nextButtonText : "FINISH" })
            }        
          })
        }
    }
    else{
      this.setState({
        showErrorMessage : true
      })
    }
  }


  previousTab = () => {
    if(this.state.currentTab !== 0){
      this.setState({      
        currentTab : this.state.currentTab - 1,
        nextButtonText : "NEXT",
        showReviewPage : false
      })
    }        
  }

  renderProgressBars = () => {    
    return this.state.forms.map((item, index) => {
      return <div 
              className={"lush-bar mx-auto col-xs-12 mt-3 " + ((index <= this.state.currentTab) ? "filled-bar" : "")}
              key={index}>
              </div>
    })
  }

  renderReviewPage = () => {

    return (
      <div hidden={!this.state.showReviewPage}>       
        <h1 className="center">REVIEW</h1>
        {this.state.forms.map((form, id) => { 
            return  (
              <div key={id}>
                <div className="center col-xs-12">
                  <hr></hr>
                  <h3>{form.title.toUpperCase()}</h3>
                  <hr></hr>
                </div>  
                {form.form.map((item, id) => {
                  return <FormField 
                          key={id}
                          dataContainer = {form.name}
                          fieldChange = {this.saveToState}
                          value = {this.state.data[form.name][item.name] || item.default || ""}
                          field={item}
                          submitActive={this.state.submit} />
                })}
              </div>
            )
          })}
      </div>
      )
  }

  renderErrorMessage = () => {
    return (
      <div className="error-container mt-4" hidden={!this.state.showErrorMessage}>
        {this.state.errorMessage}
      </div>
    )
  }

  transformFieldNames = (form) => {    
    let result = {}
    for(let field in form){    
      // First element is the object key and second is the name 
      let new_field = field.split(".")
      if(new_field.length < 2){
        new_field = new_field.join("")
        result[new_field] = form[field]  
        console.log("HERE : ", result) 
      }
      else{
        const temp_key = new_field[0]
        const name = new_field[1]
        // console.log("TEMP " , result, temp_key, result[temp_key])        
        if(result[temp_key]){
          // console.log("HERE")
          let temp = result[temp_key]
          temp[name] = form[field]
          result[temp_key] = temp
        }
        else{
          const temp = { [temp_key] : { [name] : form[field]} } 
          result = Object.assign(result, temp)          
        }        
      }
    }
    
    return result
  }

  parseMultipleForms = (form) =>{
    console.log("FORM : ", form)
    let result = {
      base : {}
    }

    const isNum = (char) => {
      return '0123456789'.indexOf(char) !== -1
    }
    for(let field in form){
      const nameLength = field.length
      const char = field.slice(nameLength - 1)
      if(isNum(char)){
        field = field.slice(0, nameLength - 1)
        if(result[char]){
          result[char] = Object.assign({[field] : form[field]}, result[char])
        }
        else{
          result[char] = {
            [field] : form[field]
          }      
        }
      }

      else{
        result.base = Object.assign({[field] : form[field]}, result.base)
      }
    }   
    
    if(Object.keys(result).length === 1){
      return result.base
    }

    let data = Object.keys(result).map((item, index) => {      
      return result[item]
    })

    console.log("RESULT : ", data)

    return data
  }


  submitForm = () => {
    // let valid = null
    for(let index in this.state.forms){      
      // if(false){
      if(!this.formIsValid(this.state.forms[index].form)){
        this.setState({
          showErrorMessage : true
        })
        return
      }
    }    

    let data = Object.assign({}, this.state.data)
    
    for(let item in data){
      let parsedData = this.parseMultipleForms(data[item])
      if(parsedData.length){
        data[item] = parsedData.map((item, index) => {          
          return this.transformFieldNames(item)
        })
      }
      else{
        data[item] = this.transformFieldNames(parsedData)
      }
    }

    console.log("DATA COMING : ", data)
    const extra = "_saveWedding/?token=AK2wQ-y06jsFJLhWxmeGObbneI2XTf-Mdjgd_1ymWC51-rU4IQpyd3xItrqjF-SVTbd2L2m_TXxBswODS3_v5wg_mv5AblEwAgTn9MjlFn54t6zPfKdSCx2ppVKh1CpGaZ-DlrOvSTgTBJSkNEW495xA37QVI0TLPLlNnG9yKeBT8QR37JZE7TVB4h4SklmmnaojIh4gCixz7nN_qRQ6fGOCS9ENU9ZnmBU_Tnvhyedwt2xMiV74XYiM8VvIe7-MZt8sLS8xuEWPItfmvtiIzTZkP6h-4i5csU791YXou4-eV45KwDULUllqN5iwAvcR_WhN6A76XxVe4X61Zsil9FoCiqwVztkOXYSUlm2gBJyfH6BY5fjsBnw{!EXTERNALAUTH!}&_id=google.com***ID***116059689252775639455"
    fetch(api + extra, {
      method: 'POST',
      headers: new Headers({
                 'Accept': 'application/json',
                 'Content-Type': 'application/json',
        }),
      body: data
    })
    .then((response) => response.json())
    .then((res) => {
      if (res.message) {
        swal("IMPORTANT!", res.message, "info");
      } else {
        swal("Great work!", "You have submitted your wedding profile.", "success");
      }
    })
    .catch((err) => {
      swal("Something went wrong!", String(err), "error");
    });
  }


  render() {
    return (
      <div className="height">
      <hr className="spacer"></hr>
        <div id="tab-container" className="mx-auto"> 
          <div className="row mx-auto col-xs-12 progressSection">            
            {this.renderProgressBars()}            
          </div>
             
          {this.state.forms.map((form, id) => {                                        
            return <Tab
                      index={id}
                      formName={form.name}
                      formLength={form.length}
                      multiple={form.multiple}                      
                      key={id}     
                      title={form.title}       
                      tabForm={form.form} 
                      hidden={id!==this.state.currentTab || !this.state.showTabs}
                      onInput={this.saveToState}
                      onEditForm={this.onEditForm}
                    />
          })}

          {this.renderReviewPage()}

          {this.renderErrorMessage()}

          <div className="center" hidden={!this.state.showTabs}>
            <button onClick={this.previousTab} className="mt-4 lush-btn">           
              <b> BACK </b>
            </button>

            <button onClick={this.nextTab} className="mt-4 ml-1 lush-btn">           
              <b> {this.state.nextButtonText} </b>
            </button>      
          </div>

          <div className="center" hidden={!this.state.showReviewPage}>
            <button onClick={this.submitForm} className="mt-4 lush-btn">           
              <b> SUBMIT </b>
            </button>
          </div>          
        </div> 
        <br></br>  
        <br></br>    

      </div>
      )
  }
};


class Tab extends Component {
  constructor(props){
    super(props)    
    this.state = {
      form : [],
      data : {},
      noOfForms : 1, 
      formLength : 0     
    }
  }

  componentDidMount(){
    this.setState({
      form : this.props.tabForm || [],
      formLength : this.props.formLength
    })    
  }

  componentWillReceiveProps(nextProps){   
    this.setState({
      form : nextProps.tabForm || [],
      formLength : this.props.formLength
    })
  }

  saveToState = (data, isValid) => {
    const { name, value } = data

    const newData = Object.assign(this.state.data, {[name]: value})
    
    this.setState({ data : newData });
    
    this.props.onInput(data, isValid, this.props.formName)
  }

  
  addNewForm = () => {
    this.setState({
      noOfForms : this.state.noOfForms + 1
    }, () => {
      this.updateForm()
    })    
  }

  removeForm = () => {
    if(this.state.noOfForms > 1){
      this.setState({
        noOfForms : this.state.noOfForms - 1
      }, () => {
        this.updateForm(true)
      })
    }
  }

  updateForm = (removed) => {
    let form = []
    
    const original_form = Object.assign(this.state.form).slice(0, this.state.formLength)
    console.log("ORIGINAL FORM : ", original_form)

    for(let i = 0; i < this.state.noOfForms; i++){ 
      
      const index = i === 0 ? '' : i
    
      for(let item in original_form){                  

        let new_item = Object.assign({}, original_form[item])
        
        new_item.name = new_item.name + String(index)        
        
        form.push(new_item)
      }
      
    }

    console.log(form.length)

    this.setState({
      form : form
    })

    const removedIndex = removed ? this.state.noOfForms : undefined
    console.log(removedIndex)
    this.props.onEditForm(form, this.props.formName, removedIndex)   
  }


  render(){
    let counter = -1
    return (
      <div hidden={this.props.hidden}>
        <div className="center">
          <h6>{this.props.title.toUpperCase()}</h6>
        </div>        
        <hr />        
        {this.state.form.map((item, id) => { 
          counter += 1                 
          return (
            <div>
              <hr className="mt-5 mb-5" hidden={ counter % this.state.formLength !== 0 || counter === 0}/>
              <FormField 
                key={id}
                fieldChange = {this.saveToState}
                value = {this.state.data[item.name] || item.default || ""}
                field={item}/>                
            </div>
          )})}

        <button 
          className="pull-right lush-btn" 
          hidden={this.state.noOfForms <= 1}
          onClick={this.removeForm}
          >
            Cancel
        </button>

        <br /><br />

        <button 
          hidden={!this.props.multiple}
          onClick={this.addNewForm}
          className="mt-4 lush-btn"
        >
          {"Add new " + this.props.title }
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Wedding/Wedding.js